var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm-video"},[_c('video',{ref:"myXmVideo",staticClass:"video-js vjs-default-skin xm-video-container",attrs:{"id":"my-xm-video","controls":"","poster":_vm.getVideoPoster(_vm.src)}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }